import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-bytedance-color-large.tsx
/**
* icon.24.logo.bytedance.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iIzMyNTliNCIgZD0ibTQgNC45MjIgMi43OC44OTR2MTIuMzc4TDQgMTkuMDg4eiIvPjxwYXRoIGZpbGw9IiMzYzhjZmYiIGQ9Im04LjM4NiAxMS4yNDIgMi43MTguNzU3djYuNjdsLTIuNzE4LjYyeiIvPjxwYXRoIGZpbGw9IiMwMGM4ZDIiIGQ9Im0xMy4wMiA5LjkzNiAyLjUzMi0uNzU2djguMTgzbC0yLjUzMy0uODI1eiIvPjxwYXRoIGZpbGw9IiM3OGU2ZGQiIGQ9Im0xNy4yMiA0LjIzNCAyLjc4Ljg5NFYxOS4wMmwtMi43OC43NTZ6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-10830
*/
const Icon24LogoBytedanceColorLarge = memo(function Icon24LogoBytedanceColorLarge(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#3259b4",
				d: "m4 4.922 2.78.894v12.378L4 19.088z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#3c8cff",
				d: "m8.386 11.242 2.718.757v6.67l-2.718.62z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#00c8d2",
				d: "m13.02 9.936 2.532-.756v8.183l-2.533-.825z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#78e6dd",
				d: "m17.22 4.234 2.78.894V19.02l-2.78.756z"
			})
		]
	});
});
//#endregion
export { Icon24LogoBytedanceColorLarge };

//# sourceMappingURL=icon-24-logo-bytedance-color-large.js.map